module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "wrapper-content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "userPanel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "userInfo"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "userPicture",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.userLogin()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "userPicture"
  }, [_c('div', {
    staticClass: "userPicture-inner"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "width": "67px",
      "height": "77px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "userText"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin && _vm.userInfo.vip_level != 210),
      expression: " isLogin && userInfo.vip_level != 210"
    }],
    staticClass: "userName",
    domProps: {
      "textContent": _vm._s(_vm.userInfo.nickname)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "userName userName-login",
    staticStyle: {
      "margin-top": "30px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.userLogin()
      }
    }
  }, [_vm._v(_vm._s(_vm.discount.shouldShow ? 'Sign in for Discount' : 'Sign in') + "\n                        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin && _vm.userInfo.vip_level == 210),
      expression: "isLogin && userInfo.vip_level == 210"
    }],
    staticClass: "userName-vip",
    domProps: {
      "textContent": _vm._s(_vm.userInfo.nickname)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin && _vm.userInfo.vip_level !== 210),
      expression: "isLogin && userInfo.vip_level !== 210"
    }],
    staticClass: "userNotice"
  }, [_vm._v("You are not WPS\n                            Premium\n                        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin && _vm.userInfo.vip_level == 210),
      expression: "isLogin && userInfo.vip_level == 210"
    }],
    staticClass: "userNotice-vip",
    staticStyle: {
      "font-family": "Cambria"
    }
  }, [_c('img', {
    staticClass: "img-vip",
    attrs: {
      "src": require("../../assets/images/icon-wpsVip.png"),
      "alt": "loading"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "notice-vip"
  }, [_vm._v("WPS Office Premium")])])])]), _vm._v(" "), _c('div', {
    staticClass: "userPrivilege"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin || (_vm.isLogin && _vm.userInfo.vip_level != 210)),
      expression: "!isLogin || (isLogin && userInfo.vip_level != 210) "
    }],
    staticClass: "PrivilegeTxt"
  }, [_vm._v(" Upgrate\n                        to WPS premium, you will enjoy\n                    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin && _vm.userInfo.vip_level == 210),
      expression: "isLogin && userInfo.vip_level == 210"
    }],
    staticClass: "PrivilegeTxt",
    staticStyle: {
      "color": "#9c9c9c",
      "font-size": "12px"
    }
  }, [_vm._v("WPS Premium Privileges\n                    ")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin || (_vm.isLogin && _vm.userInfo.vip_level != 210)),
      expression: "!isLogin || (isLogin && userInfo.vip_level != 210)"
    }],
    staticClass: "userBuy"
  }, [_c('div', {
    staticClass: "product-wrapper"
  }, [_c('div', {
    staticClass: "product",
    class: {
      selected: _vm.productId === 12
    },
    attrs: {
      "id": "product-year",
      "productId": "12"
    },
    on: {
      "click": function($event) {
        return _vm.switchProduct(12)
      }
    }
  }, [_vm._v("$" + _vm._s(_vm.isUwp ? '29.99' : '29.99') + "/Year")]), _vm._v(" "), _c('div', {
    staticClass: "product",
    class: {
      selected: _vm.productId === 6
    },
    attrs: {
      "id": "product-months",
      "productId": "6"
    },
    on: {
      "click": function($event) {
        return _vm.switchProduct(6)
      }
    }
  }, [_vm._v("$" + _vm._s(_vm.isUwp ? '18.99' : '18.99') + "/6 Months")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "btn btn-discount",
    on: {
      "click": function($event) {
        return _vm.goPremium()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.discount.shouldShow ? _vm.discount.btntxt : 'GO PREMIUM') + "\n                    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.userLogin()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.discount.shouldShow ? _vm.discount.btntxt : 'GO PREMIUM') + "\n                    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin && _vm.userInfo.vip_level == 210),
      expression: "isLogin && userInfo.vip_level == 210"
    }],
    staticClass: "userBuy-vip",
    staticStyle: {
      "height": "98px"
    }
  }, [_vm._m(2)])])]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userPicture-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-notLogin-rect.png"),
      "width": "67px",
      "height": "77px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconContainer"
  }, [_c('div', {
    staticClass: "privilegeImgWrapper"
  }, [_c('img', {
    staticClass: "privilegeImg",
    attrs: {
      "src": require("../../assets/images/icon-noAds.png"),
      "alt": "loading"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "privilegeImgWrapper"
  }, [_c('img', {
    staticClass: "privilegeImg",
    attrs: {
      "src": require("../../assets/images/icon-cloud.png"),
      "alt": "loading"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "privilegeImgWrapper"
  }, [_c('img', {
    staticClass: "privilegeImg",
    attrs: {
      "src": require("../../assets/images/icon-pdf-word.png"),
      "alt": "loading"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userBuy-vipTxt"
  }, [_vm._v("Thank you for subscribing WPS Premium. "), _c('br'), _vm._v(" More premium privileges\n                        will be coming soon.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-wrapper"
  }, [_c('div', {
    staticClass: "detailsTitle"
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("Premium Privileges")])]), _vm._v(" "), _c('div', {
    staticClass: "free-title-container"
  }, [_c('div', {
    staticClass: "free-title"
  }, [_vm._v("Free")]), _vm._v(" "), _c('div', {
    staticClass: "free-title"
  }, [_vm._v("Function")]), _vm._v(" "), _c('div', {
    staticClass: "free-title"
  }, [_vm._v("Privilege")])]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "free"
  }, [_c('div', {
    staticClass: "free-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-cloud.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('div', {
    staticClass: "item-text-title"
  }, [_vm._v("20G Free Cloud Storage")]), _vm._v(" "), _c('div', {
    staticClass: "item-text-words"
  }, [_vm._v(" You will get 20G Free"), _c('br'), _vm._v(" WPS Cloud storage"), _c('br'), _vm._v("with WPS\n                                Office"), _c('br'), _vm._v(" Premium\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "free-item"
  }, [_c('div', {
    staticClass: "item-icon-bottom"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-pdf-word.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-text-bottom"
  }, [_c('div', {
    staticClass: "item-text-title"
  }, [_vm._v("Free PDF to Word conversion")]), _vm._v(" "), _c('div', {
    staticClass: "item-text-words"
  }, [_vm._v("WPS Premium users"), _c('br'), _vm._v(" can Convert PDF files"), _c('br'), _vm._v(" to Word documents\n                                "), _c('br'), _vm._v(" for free (for PC and"), _c('br'), _vm._v(" android)"), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "function"
  }, [_c('div', {
    staticClass: "free-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-pictoword.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('div', {
    staticClass: "item-text-title"
  }, [_vm._v("Picture to Text")]), _vm._v(" "), _c('div', {
    staticClass: "item-text-words"
  }, [_vm._v(" Powerful engine"), _c('br'), _vm._v(" could recognize words"), _c('br'), _vm._v(" in you picture and"), _c('br'), _vm._v(" export as text.\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "free-item"
  }, [_c('div', {
    staticClass: "item-icon-bottom"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-docs.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-text-bottom"
  }, [_c('div', {
    staticClass: "item-text-title"
  }, [_vm._v("Save Docs as pics")]), _vm._v(" "), _c('div', {
    staticClass: "item-text-words"
  }, [_vm._v("WPS Premium users "), _c('br'), _vm._v(" can export their "), _c('br'), _vm._v("\n                                documents as pictures "), _c('br'), _vm._v(" watermark\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "privilege"
  }, [_c('div', {
    staticClass: "free-item"
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-noAds.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('div', {
    staticClass: "item-text-title"
  }, [_vm._v("No Ads")]), _vm._v(" "), _c('div', {
    staticClass: "item-text-words"
  }, [_vm._v(" WPS office Premium"), _c('br'), _vm._v("is clear and efficient"), _c('br'), _vm._v("No ADs\n                                on\n                                all\n                                your "), _c('br'), _vm._v("devices\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "free-item"
  }, [_c('div', {
    staticClass: "item-icon-bottom"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-support9devices.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-text-bottom"
  }, [_c('div', {
    staticClass: "item-text-title"
  }, [_vm._v("Multiple Devices ")]), _vm._v(" "), _c('div', {
    staticClass: "item-text-words"
  }, [_vm._v("WPS Premium support"), _c('br'), _vm._v("up to 9 connected"), _c('br'), _vm._v("devices\n                                (3PCs,"), _c('br'), _vm._v(" 6Mobiles).\n                            ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a35fdff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/v2/templates/VipIntroduce.vue
// module id = 101
// module chunks = 1